import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import './index.css';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import WhyVorpoint from './components/WhyVorpoint';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import AboutUs from './pages/AboutUs';
import AboutUsModern from './pages/AboutUsModern';
import Services from './pages/Services';
import Contact from './pages/Contact';
import OurCost from './pages/OurCost';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import HomePageAddition from './components/HomePageAddition';
import ScrollToTop from './components/ScrollToTop';
import Meta from './components/Meta';
import BackgroundEffects from './components/BackgroundEffects';
import CookieConsentBanner from './components/CookieConsentBanner';

function App() {
  const { i18n } = useTranslation();
  const [consent, setConsent] = useState(Cookies.get('vorpoint-cookie-consent'));
  const [measurementId] = useState(null);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  useEffect(() => {
    if (consent === 'true') {
      // Load tracking scripts
      const script = document.createElement('script');
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-Z0PJ5XC2QY";
      script.async = true;
      document.head.appendChild(script);

      gtag('js', new Date());
      gtag('config', 'G-Z0PJ5XC2QY');
      console.log("Google Analytics loaded");
    }
  }, [consent, measurementId]);

  return (
    <Router>
      {consent === undefined && <CookieConsentBanner setConsent={setConsent} />}
      <ScrollToTop />
      <div className={`App lang-${i18n.language}`}>
        <BackgroundEffects />
        <Header />
        <Routes>
          <Route path="/" element={
            <main>
              <Meta />
              <Hero />
              <TrustBar />
              <ServicesOverview />
              <WhyVorpoint />
              <Testimonials />
              <CallToAction />
              <HomePageAddition />
            </main>
          } />
          <Route path="/ueber-uns" element={<AboutUs />} />
          <Route path="/ueber-uns-neu" element={<AboutUsModern />} />
          <Route path="/leistungen" element={<Services />} />
          <Route path="/leistungen/:id" element={<Services />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/our_cost" element={<OurCost />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/projekte" element={<Projects />} />
          <Route path="/projekte/:id" element={<ProjectDetails />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
